export const translations = {
  en: {
    nav: {
      home: "Home",
      products: "Products & Services",
      about: "About & Compliance",
      contact: "Contact & RFQ",
      cta: "Request Quote",
      mobileCta: "Request Official Quote",
    },
    marquee: [
      "LME GRADE A COPPER CATHODES",
      "DRC MINING CONCESSIONS",
      "ALLUVIAL GOLD DORE",
      "SPODUMENE LITHIUM ORE",
      "SULPHUR GRANULARS",
      "ISO & KYC CERTIFIED",
      "TIER-1 GLOBAL LOGISTICS",
    ],
    footer: {
      tagline:
        "Direct-from-source mining, processing, and international export of high-purity copper, precious gold, critical lithium, and essential industrial minerals from the Democratic Republic of Congo.",
      navTitle: "Navigation",
      officeTitle: "Registered Office",
      inquiries: "Inquiries Portal",
      email: "Email:",
      sales: "Sales:",
      tel: "Tel:",
      rights: "Ethical Sourcing · KYC/AML Compliant Trade",
    },
    home: {
      hero: {
        badge: "Direct-from-Source · DRC Congo",
        l1: "Global Mineral",
        l2: "Supply Chains,",
        l3: "Secured at the Source.",
        sub: "Direct-from-source mining, processing, and international export of high-purity copper, precious gold, critical lithium, and essential industrial minerals from the heart of the Democratic Republic of Congo.",
        cta1: "Request Soft Corporate Offer (SCO)",
        cta2: "View Product Specifications",
      },
      trust: {
        kicker: "Trust Markers",
        title: "Proof in Purity, Process & Reach",
        m1: "Pure Copper Cathodes — LME Grade A Standard",
        m2: "International Logistics & Strict KYC/AML Compliance",
        m3: "Continents — Global Export Footprint (Asia · Europe · Americas)",
      },
      warehouse: {
        kicker: "Refined. Verified. Loaded.",
        title: "From Katanga Copperbelt to Global Ports",
        body: "Every cathode bundle is assay-verified, steel-strapped, and container-loaded under supervised protocol. Our warehouse-to-vessel chain of custody keeps your cargo documented at every checkpoint — from Lubumbashi to Durban, Dar es Salaam, and beyond.",
        cta: "Our Operations & Compliance",
        caption: "Electrolytic Copper Cathodes · Export-Ready",
      },
      grid: {
        kicker: "Commodities Portfolio",
        title: "Minerals That Move Industry",
        cta: "Full Specifications",
        rfqCard: "Need a structured quote on any commodity?",
        rfqCta: "Open RFQ Center",
      },
      creds: {
        kicker: "Registered & Verified Export Entity",
        items: ["RCCM: CD/LSH/RCCM/26-B-01257", "ID NAT: 05-B0500-N00001D", "NIF: A2625799X"],
      },
      gallery: {
        kicker: "Operations Gallery",
        title: "Real Sites. Real Cargo. Real Documentation.",
        slides: [
          "Electrolytic copper cathodes — export-ready",
          "Excavators & haul trucks — active pit operations",
          "Open-pit operations — Katanga Copperbelt",
          "Container vessel export corridors",
          "On-site documentation & loading supervision",
        ],
      },
      lead: {
        kicker: "Trade Desk",
        title: "Open a Trade Conversation",
        body: "Leave your corporate details and our export desk will respond with availability, indicative pricing, and the documentation pathway for your target commodity.",
        emailLabel: "Email:",
        telLabel: "Tel:",
        officeLabel: "Office:",
        company: "Company Name *",
        email: "Corporate Email *",
        commodity: "Commodity of Interest",
        message: "Message",
        companyPh: "Your corporation",
        emailPh: "name@company.com",
        commodityPh: "Select a commodity…",
        messagePh: "Volumes, target port, timelines…",
        submit: "Submit Trade Inquiry",
        sending: "Transmitting…",
        successKicker: "Inquiry Logged",
        successBody:
          "Your inquiry has been recorded. Our trade desk will respond within one business day. For full RFQ terms, use the RFQ Center.",
        newInquiry: "New Inquiry",
        toastOk: "Inquiry received — Reference",
        toastErr: "Submission failed. Please try again.",
      },
    },
    products: {
      kicker: "Catalog 1.1.6",
      titleA: "Our Mineral Commodities",
      titleGold: "Portfolio",
      intro:
        "Select a commodity below to load its full specification sheet, packaging standard, and industrial applications — then request a structured quote directly.",
      applications: "Primary Applications: ",
      rfq: "Request RFQ",
    },
    about: {
      kicker: "About Ore Source Mining SARLU",
      profile: {
        kicker: "Company Profile",
        title: "Ore Source Mining SARLU at a Glance",
        body: "Ore Source Mining SARLU is a registered Congolese mineral mining and export company headquartered in Lubumbashi, the heart of the Katanga Copperbelt. We source copper cathodes, copper concentrates, gold, lithium ore and industrial sulphur directly from partner concessions, and manage assay, documentation and export logistics end-to-end for industrial buyers across Asia, Europe and the Americas.",
        mission: "Mission",
        missionText: "To connect the mineral wealth of the Democratic Republic of Congo to global industry through transparent, compliant and fully documented trade.",
        vision: "Vision",
        visionText: "To be Central Africa's most trusted direct-from-source mineral export partner, recognized for purity, reliability and ethical sourcing.",
        why: "Why Partner With Us",
        whyText: "Direct concession access, verifiable registration (RCCM, ID NAT, NIF), strict KYC/AML discipline and supervised loading — so every tonne you buy is traceable from pit to port.",
      },
      titleA: "The Vital Link Between",
      titleGold: "Rich Deposits",
      titleB: "and Global Demand",
      brief:
        "Operating directly out of the Democratic Republic of Congo, we serve as the vital link between rich mineral deposits and global industrial demand. Our operations focus heavily on transparency, ethical sourcing, and maximizing local economic development.",
      ops: {
        kicker: "DRC Operations",
        title: "On the Ground in the Katanga Copperbelt",
        body: "From our registered office at 5967 AV Kasai, Q/Makutano, Lubumbashi, our field teams supervise extraction, aggregation, and assay verification across partner concessions. On-site representation means your cargo is inspected at the source — not discovered at destination.",
        list: [
          "Registered DRC entity — RCCM: CD/LSH/RCCM/26-B-01257",
          "ID NAT: 05-B0500-N00001D · NIF: A2625799X",
          "Direct concession relationships across the copperbelt",
          "Local employment & community development programs",
        ],
        caption: "On-Site Verification · Loading Dock Protocol",
      },
      logistics: {
        kicker: "Supply Chain & Logistics",
        title: "Tier-1 Multimodal Export Corridors",
        body: "Cargo moves under supervised chain of custody via road and rail from the copperbelt to the ports of Durban, Dar es Salaam, and Walvis Bay, then onward by container or bulk vessel to smelters and refineries across Asia, Europe, and the Americas. CFR and CIF incoterms supported with full marine insurance options.",
        caption: "Multimodal Export · Asia · Europe · Americas",
      },
      compliance: {
        kicker: "Compliance Protocol",
        title: "Clean International Trade Lanes — Enforced, Not Promised",
        body: "Every transaction undergoes stringent Know Your Customer (KYC) checking, strict anti-money laundering protocol, and verifiable Client Information Sheets (CIS) before any Soft Corporate Offers (SCO) or Letters of Intent (LOI) are processed.",
        cards: [
          {
            title: "KYC Verification",
            text: "Stringent Know Your Customer screening on every counterparty before engagement.",
          },
          {
            title: "AML Protocol",
            text: "Strict anti-money laundering controls across every transaction and payment lane.",
          },
          {
            title: "CIS Validation",
            text: "Verifiable Client Information Sheets processed before any SCO or LOI is issued.",
          },
          {
            title: "Clean Trade Lanes",
            text: "Documented chain of custody from concession to vessel — no exceptions.",
          },
        ],
        ctaText: "Ready to begin compliant trade onboarding? Submit your ICPO / RFQ today.",
        ctaBtn: "Submit ICPO / RFQ",
      },
    },
    contact: {
      kicker: "Contact & RFQ Center",
      titleA: "Submit an Official",
      titleGold: "ICPO / RFQ",
      intro:
        "Complete the structured request below. All submissions pass KYC/CIS verification before a Soft Corporate Offer is issued.",
      office: "Registered Office",
      trade: "Trade Desk",
      line: "Direct Line",
      note: "Accepted instruments: DLC MT700 · SBLC MT760 · TT MT103. Incoterms: CFR / CIF.",
      f: {
        company: "Full Company Name *",
        address: "Corporate Address",
        repName: "Authorized Representative",
        repTitle: "Representative Title",
        email: "Corporate Email *",
        phone: "Phone / WhatsApp",
        commodity: "Target Mineral Commodity *",
        quantity: "Target Quantity (MT / month)",
        payment: "Preferred Payment Instrument",
        incoterm: "Incoterms",
        port: "Destination / Target Loading Port",
        message: "Additional Specifications / Message",
        companyPh: "Registered corporate name",
        addressPh: "HQ street, city, country",
        repNamePh: "Full name",
        repTitlePh: "e.g. Procurement Director",
        emailPh: "name@company.com",
        phonePh: "+00 000 000 000",
        commodityPh: "Select commodity…",
        quantityPh: "e.g. 500 MT",
        paymentPh: "Select instrument…",
        incotermPh: "Select incoterm…",
        portPh: "e.g. Shanghai, Rotterdam",
        messagePh: "Assay requirements, trial volumes, delivery schedule…",
        submit: "Submit Official RFQ",
        sending: "Transmitting RFQ…",
      },
      successKicker: "RFQ Logged Successfully",
      successBody:
        "Your Request for Quote has been recorded and queued for KYC/CIS review. Our trade desk will contact your authorized representative with a Soft Corporate Offer.",
      newRfq: "Submit Another RFQ",
      toastOk: "RFQ received — Reference",
      toastErr: "Submission failed. Please verify required fields.",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      products: "Produits & Services",
      about: "À Propos & Conformité",
      contact: "Contact & RFQ",
      cta: "Demander un Devis",
      mobileCta: "Demander un Devis Officiel",
    },
    marquee: [
      "CATHODES DE CUIVRE LME GRADE A",
      "CONCESSIONS MINIÈRES EN RDC",
      "OR ALLUVIAL & LINGOTS DORÉ",
      "MINERAI DE LITHIUM SPODUMÈNE",
      "GRANULÉS DE SOUFRE",
      "CERTIFIÉ ISO & KYC",
      "LOGISTIQUE MONDIALE TIER-1",
    ],
    footer: {
      tagline:
        "Extraction, traitement et exportation internationale directement depuis la source : cuivre de haute pureté, or précieux, lithium critique et minéraux industriels essentiels, depuis la République Démocratique du Congo.",
      navTitle: "Navigation",
      officeTitle: "Siège Social",
      inquiries: "Portail des Demandes",
      email: "E-mail :",
      sales: "Ventes :",
      tel: "Tél :",
      rights: "Approvisionnement Éthique · Commerce Conforme KYC/AML",
    },
    home: {
      hero: {
        badge: "Direct de la Source · RD Congo",
        l1: "Chaînes d'Approvisionnement",
        l2: "Minérales Mondiales,",
        l3: "Sécurisées à la Source.",
        sub: "Extraction, traitement et exportation internationale directement depuis la source de cuivre de haute pureté, d'or précieux, de lithium critique et de minéraux industriels essentiels, au cœur de la République Démocratique du Congo.",
        cta1: "Demander une Offre Soft (SCO)",
        cta2: "Voir les Spécifications",
      },
      trust: {
        kicker: "Repères de Confiance",
        title: "La Preuve par la Pureté, le Processus et la Portée",
        m1: "Cathodes de Cuivre Pures — Norme LME Grade A",
        m2: "Logistique Internationale & Conformité KYC/AML Stricte",
        m3: "Continents — Empreinte d'Exportation Mondiale (Asie · Europe · Amériques)",
      },
      warehouse: {
        kicker: "Raffiné. Vérifié. Chargé.",
        title: "De la Ceinture de Cuivre du Katanga aux Ports Mondiaux",
        body: "Chaque botte de cathodes est vérifiée par essai, cerclée d'acier et chargée en conteneur sous protocole supervisé. Notre chaîne de traçabilité entrepôt-navire documente votre cargaison à chaque étape — de Lubumbashi à Durban, Dar es Salaam et au-delà.",
        cta: "Nos Opérations & Conformité",
        caption: "Cathodes de Cuivre Électrolytiques · Prêtes à l'Export",
      },
      grid: {
        kicker: "Portefeuille de Matières Premières",
        title: "Des Minéraux qui Font Avancer l'Industrie",
        cta: "Spécifications Complètes",
        rfqCard: "Besoin d'un devis structuré sur une matière première ?",
        rfqCta: "Ouvrir le Centre RFQ",
      },
      creds: {
        kicker: "Entité d'Exportation Enregistrée & Vérifiée",
        items: ["RCCM: CD/LSH/RCCM/26-B-01257", "ID NAT: 05-B0500-N00001D", "NIF: A2625799X"],
      },
      gallery: {
        kicker: "Galerie des Opérations",
        title: "Sites Réels. Cargaisons Réelles. Documents Réels.",
        slides: [
          "Cathodes de cuivre électrolytiques — prêtes à l'export",
          "Excavatrices & tombereaux — exploitation active",
          "Exploitation à ciel ouvert — Ceinture de Cuivre du Katanga",
          "Corridors d'exportation par porte-conteneurs",
          "Supervision documentaire et chargement sur site",
        ],
      },
      lead: {
        kicker: "Bureau Commercial",
        title: "Ouvrir une Discussion Commerciale",
        body: "Laissez les coordonnées de votre entreprise et notre bureau d'exportation vous répondra avec les disponibilités, les prix indicatifs et le parcours documentaire pour votre matière première cible.",
        emailLabel: "E-mail :",
        telLabel: "Tél :",
        officeLabel: "Bureau :",
        company: "Nom de l'Entreprise *",
        email: "E-mail Professionnel *",
        commodity: "Matière Première d'Intérêt",
        message: "Message",
        companyPh: "Votre société",
        emailPh: "nom@societe.com",
        commodityPh: "Sélectionnez une matière première…",
        messagePh: "Volumes, port de destination, délais…",
        submit: "Envoyer la Demande Commerciale",
        sending: "Transmission…",
        successKicker: "Demande Enregistrée",
        successBody:
          "Votre demande a été enregistrée. Notre bureau commercial vous répondra sous un jour ouvré. Pour des conditions RFQ complètes, utilisez le Centre RFQ.",
        newInquiry: "Nouvelle Demande",
        toastOk: "Demande reçue — Référence",
        toastErr: "Échec de l'envoi. Veuillez réessayer.",
      },
    },
    products: {
      kicker: "Catalogue 1.1.6",
      titleA: "Notre Portefeuille de",
      titleGold: "Matières Minérales",
      intro:
        "Sélectionnez une matière première ci-dessous pour charger sa fiche technique complète, son conditionnement et ses applications industrielles — puis demandez directement un devis structuré.",
      applications: "Applications Principales : ",
      rfq: "Demander un Devis RFQ",
    },
    about: {
      kicker: "À Propos d'Ore Source Mining SARLU",
      profile: {
        kicker: "Profil de l'Entreprise",
        title: "Ore Source Mining SARLU en Bref",
        body: "Ore Source Mining SARLU est une société congolaise enregistrée d'extraction et d'exportation de minéraux, dont le siège est à Lubumbashi, au cœur de la Ceinture de Cuivre du Katanga. Nous approvisionnons cathodes de cuivre, concentrés de cuivre, or, minerai de lithium et soufre industriel directement auprès de concessions partenaires, et gérons l'essai, la documentation et la logistique d'exportation de bout en bout pour des acheteurs industriels en Asie, en Europe et dans les Amériques.",
        mission: "Mission",
        missionText: "Relier les richesses minérales de la République Démocratique du Congo à l'industrie mondiale par un commerce transparent, conforme et entièrement documenté.",
        vision: "Vision",
        visionText: "Être le partenaire d'exportation minérale direct de la source le plus fiable d'Afrique centrale, reconnu pour sa pureté, sa fiabilité et son approvisionnement éthique.",
        why: "Pourquoi Nous Choisir",
        whyText: "Accès direct aux concessions, enregistrement vérifiable (RCCM, ID NAT, NIF), discipline KYC/AML stricte et chargement supervisé — chaque tonne achetée est traçable, de la fosse au port.",
      },
      titleA: "Le Lien Essentiel Entre",
      titleGold: "de Riches Gisements",
      titleB: "et la Demande Mondiale",
      brief:
        "Opérant directement depuis la République Démocratique du Congo, nous servons de lien vital entre de riches gisements minéraux et la demande industrielle mondiale. Nos opérations privilégient la transparence, l'approvisionnement éthique et le développement économique local.",
      ops: {
        kicker: "Opérations en RDC",
        title: "Sur le Terrain dans la Ceinture de Cuivre du Katanga",
        body: "Depuis notre siège social au 5967 AV Kasai, Q/Makutano, Lubumbashi, nos équipes de terrain supervisent l'extraction, l'agrégation et la vérification par essai dans les concessions partenaires. Une représentation sur site signifie que votre cargaison est inspectée à la source — et non découverte à destination.",
        list: [
          "Entité enregistrée en RDC — RCCM : CD/LSH/RCCM/26-B-01257",
          "ID NAT : 05-B0500-N00001D · NIF : A2625799X",
          "Relations directes avec les concessions de la ceinture de cuivre",
          "Programmes d'emploi local et de développement communautaire",
        ],
        caption: "Vérification sur Site · Protocole de Quai de Chargement",
      },
      logistics: {
        kicker: "Chaîne d'Approvisionnement & Logistique",
        title: "Corridors d'Exportation Multimodaux Tier-1",
        body: "La cargaison circule sous chaîne de traçabilité supervisée, par route et rail, depuis la ceinture de cuivre vers les ports de Durban, Dar es Salaam et Walvis Bay, puis par conteneur ou vraquier vers les fonderies et raffineries d'Asie, d'Europe et des Amériques. Incoterms CFR et CIF pris en charge avec options d'assurance maritime complète.",
        caption: "Export Multimodal · Asie · Europe · Amériques",
      },
      compliance: {
        kicker: "Protocole de Conformité",
        title: "Des Voies Commerciales Internationales Propres — Appliquées, pas Promises",
        body: "Chaque transaction fait l'objet d'une vérification Know Your Customer (KYC) rigoureuse, d'un protocole anti-blanchiment strict et de Fiches d'Information Client (CIS) vérifiables avant le traitement de toute Offre Soft (SCO) ou Lettre d'Intention (LOI).",
        cards: [
          {
            title: "Vérification KYC",
            text: "Un contrôle Know Your Customer rigoureux de chaque contrepartie avant tout engagement.",
          },
          {
            title: "Protocole AML",
            text: "Des contrôles anti-blanchiment stricts sur chaque transaction et voie de paiement.",
          },
          {
            title: "Validation CIS",
            text: "Des Fiches d'Information Client vérifiables traitées avant toute émission de SCO ou LOI.",
          },
          {
            title: "Voies Commerciales Propres",
            text: "Une chaîne de traçabilité documentée, de la concession au navire — sans exception.",
          },
        ],
        ctaText: "Prêt à démarrer un onboarding commercial conforme ? Soumettez votre ICPO / RFQ dès aujourd'hui.",
        ctaBtn: "Soumettre un ICPO / RFQ",
      },
    },
    contact: {
      kicker: "Contact & Centre RFQ",
      titleA: "Soumettez un",
      titleGold: "ICPO / RFQ Officiel",
      intro:
        "Complétez la demande structurée ci-dessous. Toutes les soumissions passent une vérification KYC/CIS avant l'émission d'une Offre Soft.",
      office: "Siège Social",
      trade: "Bureau Commercial",
      line: "Ligne Directe",
      note: "Instruments acceptés : DLC MT700 · SBLC MT760 · TT MT103. Incoterms : CFR / CIF.",
      f: {
        company: "Nom Complet de l'Entreprise *",
        address: "Adresse de l'Entreprise",
        repName: "Représentant Autorisé",
        repTitle: "Titre du Représentant",
        email: "E-mail Professionnel *",
        phone: "Téléphone / WhatsApp",
        commodity: "Matière Première Cible *",
        quantity: "Quantité Cible (MT / mois)",
        payment: "Instrument de Paiement Préféré",
        incoterm: "Incoterms",
        port: "Port de Destination / Chargement",
        message: "Spécifications Additionnelles / Message",
        companyPh: "Nom social enregistré",
        addressPh: "Rue, ville, pays du siège",
        repNamePh: "Nom complet",
        repTitlePh: "ex. Directeur des Achats",
        emailPh: "nom@societe.com",
        phonePh: "+00 000 000 000",
        commodityPh: "Sélectionnez une matière première…",
        quantityPh: "ex. 500 MT",
        paymentPh: "Sélectionnez un instrument…",
        incotermPh: "Sélectionnez un incoterm…",
        portPh: "ex. Shanghai, Rotterdam",
        messagePh: "Exigences d'essai, volumes d'essai, calendrier de livraison…",
        submit: "Soumettre le RFQ Officiel",
        sending: "Transmission du RFQ…",
      },
      successKicker: "RFQ Enregistré avec Succès",
      successBody:
        "Votre Demande de Devis a été enregistrée et mise en file pour révision KYC/CIS. Notre bureau commercial contactera votre représentant autorisé avec une Offre Soft.",
      newRfq: "Soumettre un Autre RFQ",
      toastOk: "RFQ reçu — Référence",
      toastErr: "Échec de l'envoi. Veuillez vérifier les champs requis.",
    },
  },
};
